import React from 'react';
import InfoCard from '../../ForCreator/InfoCard/InfoCard';
import heartIcon from '../../../assets/svg/icon/edc-info-heart-white.svg';
import burstIcon from '../../../assets/svg/icon/edc-info-burst-white.svg';
import searchIcon from '../../../assets/svg/icon/edc-info-search-white.svg';
import lightIcon from '../../../assets/svg/icon/edc-info-light-white.svg';
import './InfoContainer.css';

const InfoContainer = () => {
  const backgroundColor = 'transparent';
  const textColor = '#000';

  return (
    <div className="info-container-wrapper-home">
      <h2 className="info-container-heading-home">ADVERTISING RE-DEFINED</h2>
      <div className="info-container-home">
        <InfoCard
          image={heartIcon}
          heading="CREATIVE AS TARGETING"
          text="Content created by your target audience becomes your targeting. 49% of ad effectiveness is driven by creative - fact. Real people creating relatable, authentic, scroll-native content which acts as the targeting layer itself."
          backgroundColor={backgroundColor}
          textColor={textColor}
        />
        <InfoCard
          image={burstIcon}
          heading="BRANDS BUILT BY COMMUNITIES, NOT BY BRANDS"
          text="Hyper-relevant content is the key to winning attention. 80% of consumers are more likely to engage with relatable content. People crave authenticity, because people crave relatability - the key to deeper consumer engagement."
          backgroundColor={backgroundColor}
          textColor={textColor}
        />
        <InfoCard
          image={searchIcon}
          heading="OBJECTIVE OPTIMISATIONS OVER SUBJECTIVE DECISIONS"
          text="An outcome optimised performance model, powered by media and led by data. Creative insights and ROI analysed to make objective decisions. From Brand Lift Studies to conversion and ROAS data."
          backgroundColor={backgroundColor}
          textColor={textColor}
        />
        <InfoCard
          image={lightIcon}
          heading="DEMOCRATIZED OPPORTUNITIES"
          text="A solution which gives the opportunities to the many, not just the few - unlocking creativity at scale. A brand specific community of Everyday Creators, creating a stream of Everyday Content - built to beat creative fatigue."
          backgroundColor={backgroundColor}
          textColor={textColor}
        />
      </div>
    </div>
  );
};

export default InfoContainer;
